import { GOAL_DESC_WORD_LIMIT } from "config/constants";
import errorMessages from "utils/validation/errorMessages";
import { numberRequiredSchema, select2RequiredSchema, stringRequiredSchema, stringSchema, wordLimitValidation } from "utils/validation/validationHelpers";
import { object, number } from 'yup';

const goalFormSchema = object().shape({
	discipline_id: numberRequiredSchema,
	area_id: select2RequiredSchema,
	goal_id: select2RequiredSchema,
	context_id: select2RequiredSchema,
	goal_description: stringRequiredSchema,
	goal_notes: stringSchema(),
});

export default goalFormSchema;